var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header-nav" }, [
        _c("div", { staticClass: "logo" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-box" },
          _vm._l(_vm.navList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                ref: "containerBoxItem",
                refInFor: true,
                staticClass: "container-box-item",
                class: { activeTop: _vm.language === "en" },
                on: {
                  click: function ($event) {
                    return _vm.handleClick(index)
                  },
                  mouseenter: function ($event) {
                    return _vm.hoverTab(index)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "container-box-text",
                    class: { "is-active-color": _vm.hoveredTabBox === index },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.language === "zh" ? item.nameZh : item.nameEn
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                index !== 0
                  ? _c("i", { staticClass: "el-icon-caret-bottom" })
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-nav-right" },
          [
            _c(
              "i",
              {
                staticClass: "el-icon-question",
                staticStyle: { cursor: "pointer" },
                on: { click: _vm.handleHelp },
              },
              [_vm._v(_vm._s(_vm.$t("home.helpNew")))]
            ),
            _vm._v(" "),
            _vm.language === "en"
              ? _c(
                  "div",
                  {
                    staticStyle: { margin: "0 16px 0 16px", cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.handleSetLanguage("zh")
                      },
                    },
                  },
                  [_vm._v("中文\n      ")]
                )
              : _c(
                  "div",
                  {
                    staticStyle: { margin: "0 16px 0 16px", cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.handleSetLanguage("en")
                      },
                    },
                  },
                  [_vm._v("English")]
                ),
            _vm._v(" "),
            _c("router-link", { attrs: { to: "/register" } }, [
              _vm._v(_vm._s(_vm.$t("home.registerIndex"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "header-nav-right-border" }),
            _vm._v(" "),
            _c("el-avatar", { attrs: { icon: "el-icon-user-solid" } }),
            _vm._v(" "),
            !_vm.userInfo.accountName
              ? _c(
                  "div",
                  {
                    staticStyle: { margin: "0 20px 0 10px", cursor: "pointer" },
                    on: { click: _vm.handleGoLogin },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("home.noLogin")) + "\n      "
                    ),
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "class_uaername",
                    staticStyle: { margin: "0 0px 0 10px", cursor: "pointer" },
                    on: { click: _vm.handleToUserCenter },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.userInfo.accountName) +
                        "\n      "
                    ),
                  ]
                ),
            _vm._v(" "),
            _vm.userInfo.accountName
              ? _c(
                  "div",
                  {
                    staticStyle: { margin: "0 10px 0 0px", cursor: "pointer" },
                    on: { click: _vm.handleLogOut },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("home.logOut")) + "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _c(
          "div",
          {
            ref: "containerListTab",
            staticClass: "container-list-tab",
            on: {
              mouseleave: function ($event) {
                return _vm.hoverTabLeave()
              },
            },
          },
          _vm._l(_vm.navTabList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "container-list-item",
                class: {
                  "is-active":
                    _vm.currentIndex === index ||
                    _vm.currentIndexQuery === index,
                },
                on: {
                  click: function ($event) {
                    return _vm.handleClickNav(item, index)
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-tickets" }),
                _vm._v(_vm._s(item.name) + "\n        "),
                item.iconLogin && !item.iconAuth
                  ? _c("i", { staticClass: "el-icon-lock icon-position" })
                  : _vm._e(),
                _vm._v(" "),
                item.iconLogin && item.iconAuth
                  ? _c("i", {
                      staticClass: "icon iconneishenyuanguanli icon-position",
                    })
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("userLogin", {
        ref: "userLogin",
        on: { forgetPassword: _vm.handleForgetPassword },
      }),
      _vm._v(" "),
      _c("forgetPassWord", {
        ref: "forgetPassWord",
        attrs: { isEditPassword: _vm.isEditPassword },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }